import { api } from './base.api.client'
import type {
  ExecutionDetailRow,
  ExecutionListResponse,
} from '@/core/types/api.types'

export interface ExecutionFilters {
  // An index signature so this can be passed straight to the query builder,
  // which accepts any bag of scalars.
  [key: string]: string | number | undefined
  connection_id?: string
  connector_id?: string
  action_id?: string
  status?: 'success' | 'failed'
  limit?: number
  offset?: number
}

export const executionsApi = {
  list: (filters: ExecutionFilters = {}) =>
    api.get<ExecutionListResponse>('/executions', filters),

  detail: (executionId: string) =>
    api
      .get<{ execution: ExecutionDetailRow }>(
        `/executions/${encodeURIComponent(executionId)}`,
      )
      .then((d) => d.execution),
}
